/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import Struct, { StructType } from '@core/models/struct/Struct';

import { AbstractSseConnection } from './AbstractSseConnection';
import {
    StructEvent,
    SseStructType,
    SseStructure,
    MappedStructEvent,
} from '../types';
import { OutcomeDto } from '@core/mappers/struct/dtos/OutcomeDto';
import { SportDto } from '@core/mappers/struct/dtos/SportDto';
import { CategoryDto } from '@core/mappers/struct/dtos/CategoryDto';
import { mapOddTypes } from '@core/mappers/struct/OddTypeMapper';
import { mapCategories } from '@core/mappers/struct/CategoryMapper';
import { mapSports } from '@core/mappers/struct/SportMapper';
import { mapTournaments } from '@core/mappers/struct/TournamentMapper';
import { TournamentDto } from '@core/mappers/struct/dtos/TournamentDto';
import { getOfferSseHost } from '@core/services/offer/helpers';

export class StructSseConnection extends AbstractSseConnection<Partial<Struct>> {
    constructor() {
        super('structure', getOfferSseHost());
    }

    processSseEvents(events: StructEvent[]): Partial<SseStructure> {
        return events.reduce((struct: Partial<SseStructure>, event) => {
            let mappedEvent: MappedStructEvent | undefined;
            switch (event.type) {
                case SseStructType.Outcome:
                    mappedEvent = mapOddTypes([event.data as OutcomeDto])[0];
                    break;
                case SseStructType.Category:
                    mappedEvent = mapCategories([event.data as CategoryDto])[0];
                    break;
                case SseStructType.Sport:
                    mappedEvent = mapSports([event.data as SportDto])[0];
                    break;
                case SseStructType.Tournament:
                    mappedEvent = mapTournaments([event.data as TournamentDto])[0];
                    break;
            }
            const sseTypeToStructMapper: Record<SseStructType, keyof SseStructure> = {
                [SseStructType.Sport]: StructType.Sports,
                [SseStructType.Category]: StructType.Categories,
                [SseStructType.Tournament]: StructType.Tournaments,
                [SseStructType.Outcome]: StructType.OddTypes,
                [SseStructType.OddType]: StructType.OddTypes,
                [SseStructType.BetGroup]: StructType.Markets,
                [SseStructType.MarketGroup]: StructType.MarketGroupInfos,
            };
            if (!struct[sseTypeToStructMapper[event.type]]) {
                struct[sseTypeToStructMapper[event.type]] = {};
            }
            if (mappedEvent) {
                (struct[sseTypeToStructMapper[event.type]]!)[event.id] = mappedEvent;
            }
            return struct;
        }, {} as Partial<SseStructure>);
    }
}
